import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Icon, IconButton, Typography } from '@elements';
import { Box, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import React, { useState } from 'react';
import Filter from '@images/filter.svg';
import CheckIcon from '@mui/icons-material/Check';
import { useLocation, useNavigate } from 'react-router';
import ActiveFilterRound from '@elements/active-filter-circle';
import num_word from '@utils/num_word';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var TicketsByEventTitle = function TicketsByEventTitle(_ref) {
  var count = _ref.count,
    _ref$seatsCount = _ref.seatsCount,
    seatsCount = _ref$seatsCount === void 0 ? 0 : _ref$seatsCount,
    eventTypes = _ref.eventTypes;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  var location = useLocation();
  var navigate = useNavigate();
  var searchParams = new URLSearchParams(location.search);
  var selectedFilter = searchParams.get('filter') || 'all';
  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };
  var handleClose = function handleClose() {
    setAnchorEl(null);
  };
  var handleSelect = function handleSelect(filter) {
    searchParams.set('filter', filter);
    navigate({
      search: searchParams.toString()
    });
    handleClose();
  };
  var open = Boolean(anchorEl);
  var filterOptions = ['all'].concat(_toConsumableArray(eventTypes));
  var optionsNames = _objectSpread({
    all: 'Все'
  }, eventTypes.reduce(function (acc, type) {
    acc[type] = type; // can customize the names if needed
    return acc;
  }, {}));
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      mb: '26px'
    },
    children: [/*#__PURE__*/_jsxs(Typography, {
      color: "white",
      fontSize: 22,
      children: ["\u0423 \u0432\u0430\u0441 ", count, ' ', num_word(count, ['мероприятие', 'мероприятия', 'мероприятий']), " \u0438 ", seatsCount, ' ', num_word(seatsCount, ['место', 'места', 'мест'])]
    }), /*#__PURE__*/_jsxs(IconButton, {
      sx: {
        position: 'relative',
        border: '1.5px solid rgba(139, 139, 139, 0.08)',
        borderRadius: '12px',
        padding: 0
      },
      onClick: handleClick,
      children: [/*#__PURE__*/_jsx(Icon, {
        src: Filter,
        width: 48,
        height: 36
      }), searchParams.get('filter') && /*#__PURE__*/_jsx(ActiveFilterRound, {
        additionalStyles: {
          position: 'absolute',
          top: '-2px',
          right: '-2px'
        }
      })]
    }), /*#__PURE__*/_jsx(Menu, {
      anchorEl: anchorEl,
      open: open,
      onClose: handleClose,
      disableScrollLock: true,
      slotProps: {
        paper: {
          sx: {
            background: '#141E26'
          }
        }
      },
      children: filterOptions.map(function (option) {
        return /*#__PURE__*/_jsxs(MenuItem, {
          onClick: function onClick() {
            return handleSelect(option);
          },
          children: [/*#__PURE__*/_jsx(ListItemIcon, {
            children: selectedFilter === option && /*#__PURE__*/_jsx(CheckIcon, {
              htmlColor: "#FF5100",
              sx: {
                height: '24px'
              }
            })
          }), /*#__PURE__*/_jsx(ListItemText, {
            color: "white",
            primary: /*#__PURE__*/_jsx(Typography, {
              color: "white",
              children: optionsNames[option]
            })
          })]
        }, option);
      })
    })]
  });
};
export default TicketsByEventTitle;